import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import { Organization } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Pipe({
  name: "caseStatus",
  standalone: false
})
export class CaseStatusPipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );
  transform(statusId: string): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      shareReplay(),
      map((org: Organization) => {
        const status = org.statuses.find(s => s.statusId === statusId);
        return `${status?.displayName ?? "[status  not found]"}`;
      })
    );
  }
}
